import React from 'react'
import ServiceTable from './components/servicetable'
import {withRouter } from 'react-router-dom';
 function serviceAreacomponent() {
    return (
        <ServiceTable></ServiceTable>
    )
}
export default withRouter(serviceAreacomponent);
